import { useDispatch, useSelector } from "react-redux/es/exports";
import {  Typography, Stack , Box , TextField, Button, Alert } from '@mui/material';
import { useState } from "react";
import { setIpInformation } from "../features/ipInformationSlice";
import { setError } from "../features/errorsSlice";
import Loading from "./Loading.tsx"
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

const IpLookup = ({setIpStatusText}) => {
    
    const [ip, setIp] = useState("");
    const [notIpErr, setNotIpErr] = useState("");
    let [loading, setLoading] = useState(true);
    const url =`https://api.ipgeolocation.io/ipgeo?apiKey=d7ed028f02d947b9a6e9ebbbfb6fdb13&ip=${ip}`;
    const ipInformation = useSelector((state) => state.information.value);
    const errors = useSelector((state) => state.errors.value);
    const informationDispatch = useDispatch();
    const errorsDispatch = useDispatch();

    const handleSubmit = (event) => {
        event.preventDefault();
        const re = /^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/ ;
        const ok = re.exec(ip);
  
         if (!ok){
            setNotIpErr(" Enter A valid IP number ");
            informationDispatch(setIpInformation({}));
            errorsDispatch(setError("Error: Enter A valid IP number "));
            setIpStatusText("");
            setIp("");
         }else
          { 
                    setIpStatusText("Ip Details: ");
                    setNotIpErr("");             
                    fetch(url).then((res) => {


                        if (res.status === 401)  {
                            errorsDispatch(setError("error401: Account has been disabled"));
                            setLoading(false);
                            setIpStatusText("");
                            informationDispatch(setIpInformation({}));
                            setIp("");
                        }
                        if (res.status === 403)  {
                            errorsDispatch(setError("error403: IP to geolocation look-up for a domain name is done using a free subscription API key"));
                            setLoading(false);
                            setIpStatusText("");
                            informationDispatch(setIpInformation({}));
                            setIp("");
                        }
                        if (res.status === 404)  {
                            errorsDispatch(setError("error404: IP address or domain name is not found in our database"));
                            setLoading(false);
                            setIpStatusText("");
                            informationDispatch(setIpInformation({}));
                            setIp("");
                        }
                        if (res.status === 423)  {
                            errorsDispatch(setError("error423: Bogus IP address from the bogon space"));
                            setLoading(false);
                            setIpStatusText("");
                            informationDispatch(setIpInformation({}));
                            setIp("");
                            
                        }
                        if (res.status === 429)  {
                            errorsDispatch(setError("error429: Limit has reached "));
                            setLoading(false);
                            setIpStatusText("");
                            informationDispatch(setIpInformation({}));
                            setIp("");
                        }
                        if (!res.ok){
                            throw Error("check the url or network settings");
                            
                        }
                        errorsDispatch(setError(""));
                        return res.json();
                       
            
                    }).then((data) => {
                        informationDispatch(setIpInformation(data));
                        setLoading(false);
                        setIp("");
                    }).catch((e) => {
                       setIpStatusText("");
                     })
          }
     

    }

    return (

        <Box >
           
            <form onSubmit={handleSubmit}>

            <Stack> 
            <TextField label='Enter IP Address' 
             sx={{width: {xs:"300px", sm:"500px", md:"800px", lg:"900px"}}}
            value={ip}
            onChange = {(event) => setIp(event.target.value)}
            defaultValue="Normal"
            />
            {notIpErr && <Alert severity="error">{notIpErr} </Alert>}
            </Stack> 

            <Stack >
            <Button type="submit" variant="contained" >GET IP DETAILS
            </Button>

            </Stack>

            </form>
           

        </Box>



    );
}

export default IpLookup;